import script from "./SettingFormatPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingFormatPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingFormatPage.vue?vue&type=style&index=0&id=4062185c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4062185c"]])

export default __exports__